import jwtDecode from 'jwt-decode';
import { IdentityProviders } from '../../constants';
import { SiteTypes } from '../../types';
import { isPingIdentityEnabled } from './isPingIdentityEnabled';

export interface AuthorizationParams {
  token?: string;
  identity?: IdentityProviders;
  username?: string;
}

export interface GetAuthorizationParamsProps {
  siteType: SiteTypes;
  pingAuthIdentityEnabled: boolean;
  getTokenFormCookie: (tokenCookieName: string) => string;
}

export function getAuthorizationParamsFromCookies(
  props: GetAuthorizationParamsProps,
) {
  const { getTokenFormCookie, siteType, pingAuthIdentityEnabled } = props;

  const queryParams: AuthorizationParams = {};

  const isPingIdentityFlow = isPingIdentityEnabled(
    siteType,
    pingAuthIdentityEnabled,
  );

  const tokenCookieName = isPingIdentityFlow ? 'ping-token' : 'access_token';
  const accessToken = getTokenFormCookie(tokenCookieName);

  if (isPingIdentityFlow) {
    queryParams.identity = IdentityProviders.Ping;
  }

  if (accessToken) {
    queryParams.token = accessToken;

    if (!isPingIdentityFlow) {
      const decodedToken = jwtDecode<{ 'cognito:username': string }>(
        accessToken,
      );

      if (decodedToken) {
        queryParams.username = decodedToken['cognito:username'];
      }
    }
  }

  return queryParams;
}
